import checkout from "./form";

const {
  formField: {
    dear,
    taxpayers,
    taxCode,
    notificationAddress,
    phone,
    email,
    textNumber,
    business,
    title,
    sites,
    unitHeads,
    dateFounded,
  },
} = checkout;

const initialValues = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [dear.name]: "",
  [notificationAddress.name]: "",
  [phone.name]: "",
  [email.name]: "",
  [textNumber.name]: "",
  [business.name]: "",
  [title.name]: "",
  [sites.name]: "",
  [unitHeads.name]: "",
  [dateFounded.name]: "",
};

export default initialValues;
